export default {
  SET_assets(state, payload) {
    state.assets = payload
  },
}
